const qaItems = [
  {
    q: "What does Archicon Services do?",
    a: "Archicon Services provides architectural design services, creating functional and visually refined spaces for residential and commercial projects in Houston and surrounding areas.",
  },
  {
    q: "Who do they serve?",
    a: "They work with property owners, developers, and businesses seeking professional architectural design solutions — from single-family homes to large commercial developments.",
  },
  {
    q: "What services do they offer?",
    a: "Services include architectural design, concept development, construction drawings, 3D rendering, animation, renovation design, and real estate consulting.",
  },
  {
    q: "What are the key benefits?",
    a: "Clients benefit from thoughtful design, improved space functionality, enhanced visual appeal, and plans that are ready for efficient construction — all delivered with 40+ years of expertise.",
  },
  {
    q: "How does the process work?",
    a: "Initial consultation → concept development → design refinement → construction-ready plans → project support. Every step is guided by Tarit K. Chaudhuri, AIA, CCIM, BCB.",
  },
];

const galleryImages = [
  {
    src: "https://www.archiconservices.com/img/home-projects/anjali.jpg",
    label: "Dance Academy — Exterior",
  },
  {
    src: "https://www.archiconservices.com/img/home-projects/anjali-int.jpg",
    label: "Dance Academy — Auditorium",
  },
  {
    src: "https://www.archiconservices.com/img/home-projects/daria.jpg",
    label: "Home Garden & Sunroom",
  },
  {
    src: "https://www.archiconservices.com/img/home-projects/residential.jpg",
    label: "Residential Heights",
  },
];

export default function AIAnswerBlock() {
  return (
    <section id="about" className="py-28 px-6 bg-white">
      <div className="max-w-7xl mx-auto">

        {/* Top: heading + project gallery */}
        <div className="mb-16">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
            <div>
              <p
                className="text-xs tracking-widest uppercase text-amber-600 mb-3"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Quick Answers
              </p>
              <h2
                className="text-4xl md:text-5xl font-light text-stone-900 leading-tight"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                Everything You Need
                <br />
                <em className="not-italic font-semibold">to Know</em>
              </h2>
            </div>
            <p
              className="text-stone-500 text-sm leading-relaxed max-w-sm"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Archicon Services has been delivering precision-driven architectural design in Houston since 2007.
            </p>
          </div>

          {/* Project image strip */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {galleryImages.map((img, i) => (
              <div key={i} className="relative overflow-hidden group h-52">
                <img
                  src={img.src}
                  alt={img.label}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <p
                  className="absolute bottom-3 left-3 text-white text-xs tracking-wide"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {img.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom: founder + Q&A */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <div>
            <p
              className="text-stone-500 text-sm leading-relaxed mb-8"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Here are the answers to the most common questions about our architectural design work and process.
            </p>

            {/* Founder card */}
            <div className="border border-stone-100 overflow-hidden rounded-sm">
              <img
                src="https://www.archiconservices.com/img/about.jpg"
                alt="Tarit K. Chaudhuri"
                className="w-full h-72 object-cover object-center"
              />
              <div className="p-6">
                <p
                  className="text-stone-900 font-medium text-sm"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  Tarit K. Chaudhuri
                </p>
                <p
                  className="text-amber-600 text-xs tracking-wide mb-3"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  AIA · CCIM · BCB — President &amp; Founder
                </p>
                <p
                  className="text-stone-500 text-xs leading-relaxed"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  Licensed Architect in Texas since 1984. MSc in Construction Management from Texas A&amp;M University. Over 40 years spanning Architecture, Real Estate, and Construction.
                </p>
              </div>
            </div>
          </div>

          {/* Right — Q&A */}
          <div className="flex flex-col gap-0 divide-y divide-stone-100">
            {qaItems.map((item, i) => (
              <div key={i} className="py-6">
                <p
                  className="text-stone-900 font-medium text-sm mb-2"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  <strong>{item.q}</strong>
                </p>
                <p
                  className="text-stone-500 text-sm leading-relaxed"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {item.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
